import React, { useContext, useEffect, useRef, useState } from 'react';
import './assets/css/IBLUserProfile.css';
import { IoChevronDownSharp } from 'react-icons/io5';
import { FaRegFolderOpen } from 'react-icons/fa';
import { getImageUrl, getTenant, handleLogout } from '../../hooks/helpers';
import $ from 'jquery';
import { NavLink } from 'react-router-dom';
import { getGravatarUrl } from 'react-awesome-gravatar';
import { TbUser } from 'react-icons/tb';
import { useDebounce } from '../../hooks/useDebounce';
import { LuLayoutDashboard, LuLogOut } from 'react-icons/lu';
import { HiOutlineCog6Tooth } from 'react-icons/hi2';
import { GoOrganization } from 'react-icons/go';
import { Account } from '../account';
import { IBLModalLoader } from '../IBLModalLoader';
import { AppDataContext, isJSON } from '../../utils';
import styled from 'styled-components';
import { useGetGravatarOrUploadedProfileImg } from '../../hooks';
import { useTranslation } from 'react-i18next'; // Step 1

const DEFAULT_TENANT = 'main';
const STATIC_PAGES_ENABLED =
  process.env.REACT_APP_IBL_STATIC_PAGES_ENABLED === 'true';

interface IBLUserProfileProps {
  color?: string;
  profileImageSize?: number;
  className?: string;
  profileMenuTo?: string;
  showProfileMenu?: boolean;
  showSettingsMenu?: boolean;
  showLogoutMenu?: boolean;
  additionalDropdowns?: { icon: any; label: string }[];
  backgroundColor?: string;
  hoverColor?: string;
  darkMode?: boolean;
}

export const IBLUserProfile: React.FC<IBLUserProfileProps> = ({
  color = '#000',
  backgroundColor = '#FFF',
  hoverColor = '#ededed',
  profileImageSize = 35,
  additionalDropdowns = [],
  className = '',
  showProfileMenu = true,
  profileMenuTo = '/profile/activity',
  showSettingsMenu = true,
  showLogoutMenu = true,
  darkMode = false,
  ...rest
}) => {
  const { appData } = useContext(AppDataContext);
  const { t } = useTranslation('library'); // Step 2

  const [logoutStarted, setLogoutStarted] = useState(false);
  const [accountBoxFocused, setAccountBoxFocused] = useState(false);
  const [actualTenant, setActualTenant] = useState('');
  const [allTenants, setAllTenants] = useState([]);
  const [inactiveTenants, setInactiveTenants] = useState([]);
  const tenantMenuRef = useRef(null);

  const { profilePic } = useGetGravatarOrUploadedProfileImg(
    appData.userMetaData
  );

  useEffect(() => {
    const userTenant = getTenant();
    const tenants = isJSON(localStorage.getItem('tenants'))
      ? JSON.parse(localStorage.getItem('tenants'))
      : [];
    //show no more “Main” (of course unless any other tenant the user is in) or unless the user current tenant is main and he has admin right on it
    const tenantsList = Array.isArray(tenants)
      ? tenants.filter(
          (pre) =>
            (pre.key === DEFAULT_TENANT && pre.is_admin === true) ||
            pre.key !== DEFAULT_TENANT
        )
      : [];
    setAllTenants(tenantsList);
    const inactiveTenantsList = tenantsList.filter(
      (pre) => pre.key !== userTenant
    );
    setInactiveTenants(inactiveTenantsList);
    setActualTenant(userTenant);
    /*if (inactiveTenantsList.length > 0) {
      setActualTenant(userTenant);
    }*/
  }, []);

  const hideTenantSwitchDropdown = (selector) => {
    selector.removeClass('open');
    selector.attr('data-opened', 'false');
  };

  const handleUserProfileHover = () => {
    console.log('########### handleUserProfileHover');
    $(document).off(
      'click',
      '.ibl-user-profile-container, .ibl-menu-dropdown-tenant-link'
    );
    $(document).on(
      'click',
      '.ibl-user-profile-container, .ibl-menu-dropdown-tenant-link',
      function () {
        $(this).children('.ibl-menu-dropdown-container').addClass('open');
      }
    );

    //HIDING DROPDOWN WHEN CLICKING ELSEWHERE
    $(window).on('click', function (e) {
      if (
        $(
          '.ibl-user-profile-container > .ibl-menu-dropdown-container.open:visible'
        ) &&
        !$(e.target).closest('.ibl-user-profile-container').length
      ) {
        $('.ibl-menu-dropdown-container:visible').removeClass('open');
      }
    });
  };

  const handleMainTenantJSRenameInTrialMode = () => {
    //CHECK IF TOPTRIALHEADER COMPONENT IS PRESENT THEN RENAME MAIN TO TRIAL
    if (document.getElementsByClassName('ibl-trial-top-header').length) {
      const tenantLabel = document.getElementsByClassName(
        'ibl-menu-dropdown-tenant-label'
      )[0].innerHTML;
      if (
        String(tenantLabel).toUpperCase() ===
        String(DEFAULT_TENANT).toUpperCase()
      ) {
        document.getElementsByClassName(
          'ibl-menu-dropdown-tenant-label'
        )[0].innerHTML = 'trial';
      }
    }
  };

  const handleTenantSwitch = async (event, tenant) => {
    event.preventDefault();
    event.stopPropagation();
    const url = `${process.env.REACT_APP_IBL_SPA_AUTH_URL}/login/complete`;
    const param = new URLSearchParams({
      tenant,
      'redirect-to': window.location.origin,
    }).toString();

    localStorage.setItem('tenant', tenant);
    window.location.href = `${url}?${param}`;
  };

  useDebounce(
    () => {
      handleUserProfileHover();
      handleMainTenantJSRenameInTrialMode();
    },
    200,
    []
  );

  return (
    <>
      {/*IF USER IS LOGGED IN*/}
      {Object.keys(appData.userData || {}).length > 0 && (
        <div className={`ibl-user-profile-container ${className}`} {...rest}>
          {profilePic !== '' && (
            <img
              src={profilePic}
              alt={t('IBL User Profile Image')}
              className="ibl-user-profile-img"
              style={{ height: `${profileImageSize}px`, borderColor: color }}
            />
          )}
          <IoChevronDownSharp color={color} />
          <div className="ibl-menu-dropdown-container">
            <div
              className="ibl-menu-dropdown-block"
              style={{ color: color, backgroundColor: backgroundColor }}
            >
              {actualTenant !== '' && (
                <NavLink
                  aria-details={hoverColor}
                  className={
                    'ibl-menu-dropdown-link ibl-menu-dropdown-tenant-link'
                  }
                  to={'#'}
                >
                  <FaRegFolderOpen size={18} color={color} />
                  <span className="ibl-menu-dropdown-tenant-label">
                    {actualTenant}
                  </span>
                  {
                    //SHOW CHEVRON IF MORE THAN 1 TENANT
                    inactiveTenants.length > 0 && (
                      <>
                        <IoChevronDownSharp color={color} />
                        <div
                          ref={tenantMenuRef}
                          className={'ibl-menu-dropdown-container'}
                        >
                          <div
                            className={'ibl-menu-dropdown-block'}
                            style={{
                              color: color,
                              backgroundColor: backgroundColor,
                            }}
                          >
                            {inactiveTenants.map((tenant) => (
                              <IBLMenuDropdownLink
                                onClick={(event) =>
                                  handleTenantSwitch(event, tenant.key)
                                }
                                className={'ibl-menu-dropdown-link'}
                                aria-details={hoverColor}
                              >
                                {tenant.key}
                              </IBLMenuDropdownLink>
                            ))}
                          </div>
                        </div>
                      </>
                    )
                  }
                </NavLink>
              )}
              {STATIC_PAGES_ENABLED && (
                <IBLDropdownLink
                  aria-details={hoverColor}
                  className={'ibl-menu-dropdown-link'}
                  to={`/${process.env.REACT_APP_IBL_STATIC_PAGES_ENABLED_DASHBOARD_PATH}`}
                >
                  <LuLayoutDashboard size={18} color={color} />
                  <span>{t('Dashboard')}</span>
                </IBLDropdownLink>
              )}
              {showProfileMenu && (
                <IBLDropdownLink
                  aria-details={hoverColor}
                  className={'ibl-menu-dropdown-link'}
                  to={profileMenuTo}
                >
                  <TbUser size={18} color={color} />
                  <span>{t('Profile')}</span>
                </IBLDropdownLink>
              )}
              {showSettingsMenu && (
                <IBLDropdownLink
                  aria-details={hoverColor}
                  onClick={() => setAccountBoxFocused(true)}
                  className={'ibl-menu-dropdown-link'}
                  to={'#'}
                >
                  <HiOutlineCog6Tooth size={18} color={color} />
                  <span>{t('Account')}</span>
                </IBLDropdownLink>
              )}
              {Array.isArray(additionalDropdowns) &&
                additionalDropdowns.length > 0 &&
                additionalDropdowns.map(
                  ({
                    icon = <LuLogOut size={18} color={color} />,
                    label = 'Menu',
                    ...rest
                  }) => (
                    <IBLDropdownLink
                      aria-details={hoverColor}
                      className={'ibl-menu-dropdown-link'}
                      to={'#'}
                      {...rest}
                    >
                      {icon}
                      <span>{label}</span>
                    </IBLDropdownLink>
                  )
                )}
              {showLogoutMenu && (
                <IBLDropdownLink
                  aria-details={hoverColor}
                  onClick={(event) => {
                    event.preventDefault();
                    setLogoutStarted(true);
                    handleLogout();
                  }}
                  className={'ibl-menu-dropdown-link'}
                  to={'#'}
                >
                  <LuLogOut size={18} color={color} />
                  <span>{t('Log Out')}</span>
                </IBLDropdownLink>
              )}
            </div>
          </div>
        </div>
      )}
      {accountBoxFocused && (
        <Account
          darkMode={darkMode}
          onModalClose={() => setAccountBoxFocused(false)}
        />
      )}
      {logoutStarted && (
        <IBLModalLoader displayText={t('Log out in progress...')} />
      )}
    </>
  );
};

const IBLDropdownLink = styled(NavLink)`
  &:hover {
    background-color: ${(props) => props?.['aria-details']};
  }
`;
const IBLMenuDropdownLink = styled.div`
  &:hover {
    background-color: ${(props) => props?.['aria-details']};
  }
`;
